import { Controller, useFormContext } from 'react-hook-form';
import tw from 'twin.macro';
import { useTranslation } from 'next-i18next';

import { CheckboxGroup, Title, Combobox } from '@restworld/ui-ds';

import {
  employerRestaurantJpStatusFilterAtom,
  employerRestaurantLocationFilterAtom,
} from './employer-restaurants.atoms';
import { useAtomValue } from 'jotai';
import useEmployerRestaurantLocations from '../hooks/use-employer-restaurant-locations';

export function RestaurantJpStatusFilter() {
  const { t: translateCommon } = useTranslation('common');
  const { control } = useFormContext();
  const defaultJpStatus = useAtomValue(employerRestaurantJpStatusFilterAtom);

  return (
    <FiltersContainer title="">
      <Controller
        name="jpStatus"
        defaultValue={defaultJpStatus}
        control={control}
        render={({ field }) => {
          const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const fieldValue = field.value ? [...field.value] : [];
            const value = e.target.id;
            const newData = fieldValue.includes(value) ? fieldValue.filter((v) => v !== value) : [...fieldValue, value];
            field.onChange(newData);
          };
          return (
            <CheckboxGroup
              variant="box"
              isOrientation="horizontal"
              mode="clickable"
              options={[
                {
                  id: 'open',
                  key: 'open',
                  label: translateCommon('only_businesses_with_open_positions'),
                },
              ]}
              {...{ ...field, onChange }}
              tw="relative md:right-3"
            />
          );
        }}
      />
    </FiltersContainer>
  );
}

export function RestaurantLocationFilter({ ...rest }) {
  const { t: translateCommon } = useTranslation('common');
  const { control } = useFormContext();
  const locations = useEmployerRestaurantLocations();
  const defaultLocation = useAtomValue(employerRestaurantLocationFilterAtom);

  return (
    <FiltersContainer title={translateCommon('location')}>
      <Controller
        name="location"
        control={control}
        defaultValue={defaultLocation}
        render={({ field }) => (
          <Combobox
            {...rest}
            value={field.value}
            onChange={(location: string) => {
              field.onChange(location);
            }}
            dropdownList={locations.data}
            placeholder={translateCommon('select_location')}
            fullwidth
          />
        )}
      />
    </FiltersContainer>
  );
}

const FiltersContainer = ({ title, children }: { title: string; children?: React.ReactNode }) => (
  <FilterContainer>
    <FilterTitle title={title} />
    <MainContent>{children}</MainContent>
  </FilterContainer>
);

const FilterTitle = ({ title }: { title: string }) => (
  <Title content={title} fontWeight="medium" fontSize="base" twStyle={tw`leading-6`} />
);

const MainContent = tw.div``;

const FilterContainer = tw.div`flex flex-col gap-4`;
